module.exports = '/ng-templates/shared/login/account-pairing-modal/auth-pairing-response-modal.tpl.ftl';
